import "./App.scss";
import ToDoList from "./components/to-do-list";

function App() {
  return (
    <div className="App">
      <ToDoList />
      <p className="credits">@Ruttika ©2022</p>
    </div>
  );
}

export default App;
